import { render, staticRenderFns } from "./partner_verified_detail_base.vue?vue&type=template&id=5f4650dc&scoped=true"
import script from "./partner_verified_detail_base.vue?vue&type=script&lang=js"
export * from "./partner_verified_detail_base.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f4650dc",
  null
  
)

export default component.exports